import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ProductLogoMediumStorageAndFiles } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS, useTranslation } from "@/lib/i18n";

export const Route = createFileRoute("/_staff/storage-files/_list")({
  component: StorageFilesLayout,
});

function StorageFilesLayout() {
  const { t } = useTranslation(defaultNS);
  useDocumentTitle(t("pages.storageFiles.title"));

  const tabs = [
    {
      to: "/storage-files/folders",
      children: t("pages.storageFiles.tabs.folders"),
    },
    {
      to: "/storage-files/files",
      children: t("pages.storageFiles.tabs.files"),
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={ProductLogoMediumStorageAndFiles}
        name={t("pages.storageFiles.title")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
